import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import FileUploadModalUI from './FileUploadModalUI.js'

class FileUploadModalSF extends Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fileInput = React.createRef();

        this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      customFileName: ''
    }
  }

  render() {
    return (
      <FileUploadModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        titleLabel={this.props.titleLabel}
        // modes
        uploadMode={this.props.uploadMode}
        submitted={this.state.submitted}
        // button click handlers
        onCancelClick={this.props.onCancelClick}
              // form
        fileInput={this.fileInput}
        multiple={this.props.multiple}
        handleSubmit={this.handleSubmit}
        hint={this.props.hint}
        customFileName={this.state.customFileName}
        onCustomFileNameChange={this.onCustomFileNameChange}
      />
    )
  }

   componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onCustomFileNameChange = (value) => {
    this.setState({ customFileName: value })
  }

  handleSubmit(event) {
    event.preventDefault();
    if (!this.fileInput.current || this.fileInput.current.files.length === 0) {
      this.setState({
        errorList: [{ message: 'Please select a file.' }],
      });
      return;
    }
    console.log(`Selected file - ${this.fileInput.current.files[0].name}`)

    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    for (let file of this.fileInput.current.files) {
      this.getFileUploadSignedUrl(file)
    }
  }

  getFileUploadSignedUrl(file) {
    let context = this.props.context
    let effectiveFileName = this.getEffectiveFileName(file)
    let getResource = `${RestApiUtils.getServerUrl(context)}${this.props.signedUrlApi}` +
      `?fileName=${encodeURIComponent(effectiveFileName)}&type=${file.type}&size=${file.size}`
    console.log('-> GET', getResource)
    fetch(getResource, {
      headers: RestApiUtils.getHeaders(context),
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('<- GET', getResource, json)
        if (json.errorList.length)
          this.setState({ submitted: false, errorList: json.errorList })
        else
          this.uploadFile(json.signedUrl, file)
      })
  }

  getEffectiveFileName(file) {
    let customName = this.state.customFileName && this.state.customFileName.trim()
    if (!customName)
      return file.name

    let originalExt = ''
    let dotIndex = file.name.lastIndexOf('.')
    if (dotIndex > 0)
      originalExt = file.name.substring(dotIndex)

    let hasExt = customName.lastIndexOf('.') > 0
    return hasExt ? customName : customName + originalExt
  }

  uploadFile = (signedUrl, file) => {
    console.log('uploadFile', signedUrl, file)
    let effectiveFileName = this.getEffectiveFileName(file)
    let putResource = signedUrl.signedUrl
    console.log('-> PUT', putResource)
    fetch(putResource, {
      method: 'put',
      body: file,
    })
      .then((response) => {
        console.log('<- PUT', putResource)
        this.props.onUpload(signedUrl.fileId, effectiveFileName, file.type, file.size)
        setTimeout(() => {
          this.setState({
            successMsg: null, submitted: false, customFileName: ''
          })
          this.props.onCancelClick()
        }, 1000)
      })
  }
}

export default withRouter(FileUploadModalSF)
